import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { setMessage } from '../../store/slices/message'
import CurdTokenervice from '../../services/axios/CurdTokenervice'

export const getStudentData = createAsyncThunk('studentdata/getGradeData', async (arg, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    const { token, gradeId } = arg
    try {
        const res = await CurdTokenervice.getStudentData(token, "getStudentData", gradeId);
        thunkAPI.dispatch(setMessage(res.data.message))
        return res.data
    } catch (error) {
        const message = error.message
        thunkAPI.dispatch(setMessage(message))
        return rejectWithValue(error.message)
    }
})

const studentData = createSlice({
    name: 'studentdata',
    initialState: { isloading: false, studentData: [], message: '' },
    reducers: {
        delMessage: (state, action) => {
            state.message = ''
        }
    },
    extraReducers: (builder) => {
        builder
        // Get All Student Data
        .addCase(getStudentData.pending, (state) => {
            state.isloading = true
            state.message = ''
        })
        .addCase(getStudentData.fulfilled, (state, action) => {
            state.isloading = false;
            state.studentData = action.payload;
            state.message = ''
        })
        .addCase(getStudentData.rejected, (state, action) => {
            state.isloading = false
            state.message = action.payload
        })
    },
})

export const { delMessage } = studentData.actions
export default studentData.reducer